/**
 * Fields required before SMS / GPRS commands (including output activation).
 * Matches API DeviceTrackerService.EnsureTrackerCommandPrerequisites.
 */
export function getTrackerCommandMissingFieldLabels (tracker, t) {
  const missing = []
  if (!String(tracker?.password || '').trim()) {
    missing.push(t('TrackerCommandPrerequisites.Password', 'Password'))
  }
  if (!String(tracker?.phoneNumber || '').trim()) {
    missing.push(t('TrackerCommandPrerequisites.PhoneNumber', 'Phone number'))
  }
  return missing
}

export function getApiErrorDisplayedMessage (error, fallbackMessage) {
  const apiMessage = error?.response?.data?.message
  if (typeof apiMessage === 'string' && apiMessage.trim()) {
    return apiMessage.trim()
  }
  return fallbackMessage
}
